import { FunctionComponent, PropsWithChildren, useEffect, useState } from 'react';
import { Button } from '@tv2/ui-system/components/Button';
import { useRouter } from 'next/navigation';
import { useProfiles } from '@/api/profiles/useProfiles';
import { CloseBasicNext } from '@tv2/ui-system/icons/next/navigation/CloseBasicNext';
import { useOverlayDisplayedTrack } from '@tv2/lib-offspring/hooks/tracking/useOverlayDisplayedTrack';
import { useUserInteractionTrack } from '@tv2/lib-offspring/hooks/tracking/useUserInteractionTrack';
import Modal from '@tv2/lib-offspring/components/messages/Modal';

export const ProfileOnboarding: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const { messages } = useProfiles();
  const [visible, setVisbility] = useState(false);
  const router = useRouter();
  const trackUserInteraction = useUserInteractionTrack();
  useEffect(() => {
    if (messages.length > 0) {
      setVisbility(true);
    }
  }, [messages]);

  if (!visible) return <>{children}</>;

  function dismissInfoBox() {
    trackUserInteraction({ data: { label: 'profiles.onboarding.dismiss' } });
    setVisbility(false);
  }

  function goToProfile() {
    trackUserInteraction({ data: { label: 'profiles.onboarding.tilpas-profiler' } });
    setVisbility(false);
    router.push('/profil');
  }

  return (
    <>
      {children}
      <ProfileOnboardingModal
        messages={messages}
        dismissInfoBox={dismissInfoBox}
        goToProfile={goToProfile}
      />
    </>
  );
};
type ProfileOnboardingModalProps = {
  messages: string[];
  dismissInfoBox: () => void;
  goToProfile: () => void;
};

function ProfileOnboardingModal({
  messages,
  dismissInfoBox,
  goToProfile,
}: ProfileOnboardingModalProps) {
  useOverlayDisplayedTrack({ data: { overlay: ['profile:onboarding'], headline: messages[0] } });
  return (
    <Modal onClose={() => dismissInfoBox()}>
      <div className="relative flex flex-col my-0 mx-auto w-full w-max-[640px] w-max-[min(93vw, 640px)]">
        <div>
          <div
            role="button"
            onKeyDown={() => dismissInfoBox()}
            onClick={() => dismissInfoBox()}
            tabIndex={0}
            title="Luk info"
            className="flex justify-center items-center cursor-pointer w-[40px] h-[40px] z-[3] absolute overflow-visible top-3 right-3"
          >
            <CloseBasicNext className="invert w-5 h-5" />
          </div>
          <img className="w-full" src="/assets/images/onboarding.png" alt="presentation" />
        </div>
        <div className="px-10 pb-10 pt-6 bg-midnight">
          <section className=" text-white">
            <h3 className="text-subheadline-s pb-5 flex">{messages[0]}</h3>
            <div className="pb-10">{messages[1]}</div>
          </section>
          <section className="flex justify-center gap-4">
            <Button color="secondary" darkMode onClick={dismissInfoBox}>
              Senere
            </Button>
            <Button color="primary" darkMode onClick={goToProfile}>
              Tilpas profiler
            </Button>
          </section>
        </div>
      </div>
    </Modal>
  );
}
